import React from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'

export interface IFieldCustomProps<T> {
  component: React.FC<IControlProps<{ value?: T }>>
  value: T
}

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldCustom = <T,>({ component: Component, ...r }: IControlProps<IFieldCustomProps<T>>) => {
  return <Component {...r} />
}

export default FieldCustom
